module.exports = __webpack_public_path__ + "media/MRI10-ad.94ba9d8a.mp3";